module.exports = __webpack_public_path__ + "static/media/XL.0b8a0170.jpg";